import NavLink from '../shared/buttons/nav-link';
import Button from '../shared/buttons/button';
import { useNavigate } from 'react-router-dom';
import { useStartStudentExamMutation } from '../../hooks/react-query/use-student-exam';
import { StudentExamType } from '../../api/student-exam';
import { ExamType } from '../../api/exam';

export type ExamInfoActionPropsType = {
  exam: ExamType;
  studentExam: StudentExamType;
};

function ExamInfoAction({ exam, studentExam }: ExamInfoActionPropsType) {
  const navigate = useNavigate();
  const { mutateAsync: startStudentExam } = useStartStudentExamMutation();

  if (!exam.isInitiated)
    return (
      <div className='text-center'>
        <p>داوطلب گرامی، این آزمون در حال حاضر فعال نیست.</p>
        <p>
          <span>این آزمون حداکثر تا تاریخ </span>
          <span className='font-medium'>{new Date(exam.initiated).toLocaleDateString('fa')}</span>
          <span> فعال خواهد شد.</span>
        </p>
        <NavLink to='/exams' size='3xl' color='indigo' content='بازگشت' className='mx-auto my-4' />
      </div>
    );

  if (exam.isExpired)
    return (
      <div className='text-center'>
        <p>داوطلب گرامی، مهلت شرکت در این آزمون به پایان رسیده است.</p>
        <p>
          <span>این آزمون تا تاریخ </span>
          <span className='font-medium'>{new Date(exam.expired).toLocaleDateString('fa')}</span>
          <span> فعال بوده است.</span>
        </p>
        <NavLink to='/exams' size='3xl' color='indigo' content='بازگشت' className='mx-auto my-4' />
      </div>
    );

  if (studentExam.status === 0)
    return (
      <>
        <Button
          content='شروع آزمون'
          color='green'
          colorWeight={600}
          size='3xl'
          onClick={async () => {
            await startStudentExam(studentExam.id);
            navigate(`/exams/${exam.id}`);
          }}
          className='mx-auto my-4'
        />
        <NavLink to='/exams' size='3xl' color='indigo' content='بازگشت' className='mx-auto my-4' />
      </>
    );
  if (studentExam.status === 1)
    return (
      <>
        <NavLink
          to={`/exams/${exam.id}`}
          content='ادامه آزمون'
          color='green'
          colorWeight={600}
          size='3xl'
          className='mx-auto my-4'
        />
        <NavLink to='/exams' size='3xl' color='indigo' content='بازگشت' className='mx-auto my-4' />
      </>
    );

  return null;
}

export default ExamInfoAction;
